import styled from "@emotion/styled"
import { Container } from "@mui/material"

const UnderConstruction = styled(Container)`
  &&& {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 25vh;
    padding-bottom: 25vh;
  }
`

const Portfolio: React.FC = () => {
  return (
    <UnderConstruction maxWidth='lg'>
      <h1>Currently Under Construction</h1>
      <h2>Come back a little later to see what it's all about...</h2>
    </UnderConstruction>
  )
}

export default Portfolio
